import React, { useState, useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import PermissionDropdown from './PermissionDropdown'
import Table from 'react-bootstrap/Table'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons'
import { useRoleEmployees } from 'api/hooks/use-role-employees'
import TableLoading from 'shared/tables/table-loading'
import TableFooter from 'shared/tables/table-footer'

function ChangePermission({ setShow, show, role, roleId, permissionId = '' }) {
  const [params, setParams] = useState({
    active: 'true',
    role_id: role.id,
    withPermissionRemoved: 'true',
    permission_id: permissionId || '',
    perPage: 25,
    page: 1
  })
  const handleClose = () => {
    setShow(false)
  }

  const { data, isSuccess, isLoading } = useRoleEmployees({
    params: params,
    options: {
      enabled: !!params.permission_id && !!params.role_id
    }
  })

  const Check = () => {
    return <FontAwesomeIcon icon={faCheck} className="text-success" />
  }

  const Times = () => {
    return <FontAwesomeIcon icon={faTimes} className="text-danger" />
  }

  useEffect(() => {
    if (permissionId) {
      setParams((prev) => ({
        ...prev,
        permission_id: permissionId
      }))
    }
  }, [permissionId]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Modal show={show} onHide={handleClose} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Test Permission Removal from {role.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row className="sticky-top bg-white pb-4 pt-2 border-bottom mb-4">
          <Col sm={1}></Col>
          <Col sm={10}>
            <div>Select the permission you want to remove</div>
            <div className="mt-2">
              <PermissionDropdown
                roleId={roleId}
                params={params}
                setParams={setParams}
              />
            </div>
          </Col>
          <Col sm={1}></Col>
        </Row>
        <Row className="mt-4">
          <Col sm={1}></Col>
          <Col sm={10}>
            <Table bordered responsive size="sm">
              <thead>
                <tr>
                  <th>Employee</th>
                  <th className="text-center">Maintain Permission</th>
                  <th className="text-center">From Role</th>
                </tr>
              </thead>
              <tbody>
                {isLoading && <TableLoading columns={3} />}
                {isSuccess &&
                  data.data.map((a) => (
                    <tr key={`employee-access-row-${a.id}`}>
                      <td>
                        {a.external_id}
                        <span className="text-muted ms-4 small">
                          {a.department_name}
                        </span>
                      </td>
                      <td
                        className={`text-center ${
                          data?.new_effective_permissions.filter(
                            (p) => p.employee_id === a.id
                          )?.length > 0
                            ? ''
                            : 'bg-light'
                        }`}
                      >
                        {data?.new_effective_permissions.filter(
                          (p) => p.employee_id === a.id
                        )?.length > 0 ? (
                          <Check />
                        ) : (
                          <Times />
                        )}
                      </td>
                      <td
                        className={`text-center ${
                          data?.new_effective_permissions.filter(
                            (p) => p.employee_id === a.id
                          )?.length > 0
                            ? ''
                            : 'bg-light'
                        }`}
                      >
                        {data?.new_effective_permissions.filter(
                          (p) => p.employee_id === a.id
                        )?.length > 0
                          ? data?.new_effective_permissions
                              .filter((p) => p.employee_id === a.id)
                              .map((p) => (
                                <div
                                  key={`employee-access-${a.id}-${p.employee_id}-${p.role_id}`}
                                  className="text-muted me-2 small"
                                >
                                  {p.role_name} Value: {p.permission_value}
                                </div>
                              ))
                          : 'No Access'}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
            {isSuccess && data.meta.total > 25 && (
              <div className="mt-4">
                <TableFooter
                  meta={data?.meta}
                  setParams={setParams}
                  params={params}
                />
              </div>
            )}
          </Col>
          <Col sm={1}></Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}

export default ChangePermission
